import { Outlet } from "react-router-dom";

const CategoriesDash = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default CategoriesDash;
